module.exports = __webpack_public_path__ + "static/media/sr.5fb02768.svg";